module.exports = __webpack_public_path__ + "media/images/White Small Label Top-80f27a8b6f579a447492d96836dbaeb4.svg";